import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH,
  ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE,
  type ElectronicSignatureTemplateConfigurationUpsertBody,
  type ElectronicSignatureTemplateConfigurationUpsertResponse,
} from "./electronic-signature-template-configuration.types";

export function useElectronicSignatureTemplateConfigurationUpsertMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    ElectronicSignatureTemplateConfigurationUpsertResponse,
    Error,
    ElectronicSignatureTemplateConfigurationUpsertBody
  >({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.put<ElectronicSignatureTemplateConfigurationUpsertResponse>(
        ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_API_PATH,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [ELECTRONIC_SIGNATURE_TEMPLATE_CONFIGURATION_RESOURCE],
      });
    },
  });
}
